import React, { useState, useContext, useEffect } from "react";

import { Check } from "react-feather";

import { FormTextInput } from "../../Components/FormTextInput";

import { Country, State, City } from "country-state-city";

import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { useEnterKey } from "../../Hooks/useEnterKey";

import { AuthContext } from "../../Context/AuthContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";

import TopBar from "../../Components/TopBar";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import LogoAuthNavbar from "../../NewComponents/LogoAuthNavbar";
import CreateOrderNav from "../../NewComponents/CreateOrderNav";
import NewButton from "../../NewComponents/NewButton";

import { ReactComponent as NOTRY } from "../../assets/icons/Notarization.svg";
import { ReactComponent as EXPEDITED } from "../../assets/icons/expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../assets/icons/HardCopy.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import SearchSelect from "../../NewComponents/SearchSelect";
import { expeditedPlusLanguages } from "../../Data/ExpeditePlusLanguages";
import { USPriorDelivery, otherCitiesDelivery } from "../Order/OrderOptions";
import { v4 as uuidv4 } from "uuid";
import { firestore } from "../../firebase.config";
import PopUpModal from "../../NewComponents/PopUpModal";
import { ReactComponent as ADDRESS } from "../../assets/icons/Address.svg";
import SelectSearch from "../../NewComponents/select-search";
import { getExpeditedPriceLabel, formatTotal, getExpeditedFreeOrders } from "../../Data/Functions";


const QuoteOptions = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);

  const { signedIn } = useContext(AuthContext);

  const { quote, setQuote, userData, teamData } = useContext(DataContext);

  const [continueButton, setContinueButton] = useState("Continue to Contact");
  const [generalNote, setGeneralNote] = useState("");

  const [notarization, setNotarization] = useState(false);
  const [expedited, setExpedited] = useState(false);
  const [expeditedPlus, setExpeditedPlus] = useState(false);
  const [hardCopy, setHardCopy] = useState(false);

  const [hardCopyCountry, setHardCopyCountry] = useState({label: "", value: ""});
  const [hardCopyMethod, setHardCopyMethod] = useState("");
  const [hardCopyRequireSignature, setHardCopyRequireSignature] = useState(false);

  const [hardCopyFirstName, setHardCopyFirstName] = useState("");
  const [hardCopyLastName, setHardCopyLastName] = useState("");
  const [hardCopyState, setHardCopyState] = useState({label: "", value: ""});
  const [hardCopyCity, setHardCopyCity] = useState({label: "", value: ""});
  const [hardCopyZipCode, setHardCopyZipCode] = useState("");
  const [hardCopyStreet, setHardCopyStreet] = useState("");
  const [hardCopyApartment, setHardCopyApartment] = useState("");
  const [newAddressModal, setNewAddressModal] = useState(false);
  const [editAddressIconSelected, setEditAddressIconSelected] = useState("");

  const [saveAddress, setSaveAddress] = useState(false);
  const [addressName, setAddressName] = useState("");
  const [selectedMyAddress, setSelectedMyAddress] = useState("");
  const [selectedMyCountry, setSelectedMyCountry] = useState("");
  const [selectedMyMethod, setSelectedMyMethod] = useState("");
  const [editAddress, setEditAddress] = useState("");

  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [similarClients, setSimilarClients] = useState([]);

  const [editFirstName, setEditFirstName] = useState("");
  const [editLastName, setEditLastName] = useState("");
  const [editState, setEditState] = useState({label: "", value: ""});
  const [editCity, setEditCity] = useState({label: "", value: ""});
  const [editZipCode, setEditZipCode] = useState("");
  const [editStreet, setEditStreet] = useState("");
  const [editApartment, setEditApartment] = useState("");
  const [editCountry, setEditCountry] = useState({label: "", value: ""});
  const [editAddressName, setEditAddressName] = useState("");
  const [saveEditsBtnText, setSaveEditsBtnText] = useState("Save");
  const [myDeliveryFocus, setMyDeliveryFocus] = useState({
    country: false,
    delivery: false,
  });
  const [newDeliveryFocus, setNewDeliveryFocus] = useState({
    country: false,
    delivery: false,
  });
  const countries = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

    const getStates = (selectedCountry) =>  State.getStatesOfCountry(selectedCountry).map(state => ({
        label: state.name,
        value: state.isoCode
      }));
  
    const getCities = (selectedState, selectedCountry) => City.getCitiesOfState(selectedCountry, selectedState).map(city => ({
        label: city.name,
        value: city.name
      }));
  const [deleteModalAddress, setDeleteModalAddress] = useState(null);
  const [deleteBtnText, setDeleteBtnText] = useState('Delete Address');
  const [activeDropdown, setActiveDropdown] = useState(null);
  
  useEffect(() => {
    if (signedIn && userData && userData.teamId && clientFirstName !== "") {
      getClientsDetails().then((clients) => setSimilarClients(clients));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn, userData, clientFirstName, clientLastName]);

  const getClientsDetails = async () => {
    
    let clients = [];

    await firestore
      .collection("quotes")
      .where("teamId", "==", userData.teamId)
      .where("clientFirstName", "==", clientFirstName.toLowerCase())
      .get()
      .then((qSnap) => {
        if (!qSnap.empty) {
          let data = qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          let filteredClientsName = [];

          data
            .filter((n) =>
              clientLastName !== ""
                ? n.clientLastName.length === clientLastName ||
                n.clientLastName.includes(clientLastName) ||
                n.clientLastName.includes(clientLastName.toLowerCase())
                : true
            )
            .forEach((quote) => {
              if (!filteredClientsName.includes(quote.clientLastName)) {
                filteredClientsName.push(quote.clientLastName);
                const filtered = data.filter(
                  (o) => o.clientLastName === quote.clientLastName
                );
                clients.push({
                  id: uuidv4(),
                  firstName: quote.clientFirstName,
                  lastName: quote.clientLastName,
                  totalOrders: filtered.length,
                });
              }
            });
        }
      });
    await firestore
      .collection("quotes")
      .where("teamId", "==", userData.teamId)
      .where("clientFirstName", "==", capitalize(clientFirstName))
      .get()
      .then((qSnap) => {
        if (!qSnap.empty) {
          let data = qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          let filteredClientsName = [];

          data
            .filter((n) =>
              clientLastName !== ""
                ? n.clientLastName.length === clientLastName ||
                n.clientLastName.includes(clientLastName) ||
                n.clientLastName.includes(clientLastName.toLowerCase())
                : true
            )
            .forEach((quote) => {
              if (!filteredClientsName.includes(quote.clientLastName)) {
                filteredClientsName.push(quote.clientLastName);
                const filtered = data.filter(
                  (o) => o.clientLastName === quote.clientLastName
                );
                clients.push({
                  id: uuidv4(),
                  firstName: quote.clientFirstName,
                  lastName: quote.clientLastName,
                  totalOrders: filtered.length,
                });
              }
            });
        }
      });
    return clients;
  };

  const capitalize = (value) => {
    if (value.length > 1) {
      const array = value.split(" ");
      const capitalizeWordArray = array.map((data) => {
        if (data.length > 1) {
          return (
            data.slice(0, 1).toUpperCase() + data.slice(1, -1) + data.slice(-1)
          );
        }
        return data.toUpperCase();
      });
      return capitalizeWordArray.join(" ");
    } else {
      return value.toUpperCase();
    }
  };

  useEffect(() => {
    setNotarization(quote.notarization || false);
    setExpedited(quote.expedited || false);
    setExpeditedPlus(
      getExpeditedPlusAvaliblity() ? quote.expeditedPlus || false : false
    );
    setHardCopy(quote.hardCopy || false);
      if (quote.hardCopyExtra && quote.hardCopyExtra.newAddress) {
        setHardCopyMethod(
          quote.hardCopyExtra ? quote.hardCopyExtra.method || "" : ""
        );
      } else {
        setSelectedMyMethod(
          quote.hardCopyExtra ? quote.hardCopyExtra.method || "" : ""
        );
      }
      setHardCopyCountry(
        quote.hardCopyExtra ? {label: quote.hardCopyExtra.country, value: quote.hardCopyExtra.countryIsoCode } || "" : ""
      );
      setHardCopyFirstName(
        quote.hardCopyExtra ? quote.hardCopyExtra.firstName || "" : ""
      );
      setHardCopyLastName(
        quote.hardCopyExtra ? quote.hardCopyExtra.lastName || "" : ""
      );
     
      setHardCopyState(
        quote.hardCopyExtra ? {label: quote.hardCopyExtra.region, value: quote.hardCopyExtra.regionIsoCode } || "" : ""
      );
      setHardCopyCity(
        quote.hardCopyExtra ? {label: quote.hardCopyExtra.city, value: quote.hardCopyExtra.cityIsoCode } || "" : ""
      );
      setHardCopyZipCode(
        quote.hardCopyExtra ? quote.hardCopyExtra.zipCode || "" : ""
      );
      setHardCopyStreet(
        quote.hardCopyExtra ? quote.hardCopyExtra.street || "" : ""
      );
      setHardCopyApartment(
        quote.hardCopyExtra ? quote.hardCopyExtra.apartment || "" : ""
      );
      setHardCopyRequireSignature(
        quote.hardCopyExtra
          ? quote.hardCopyExtra.requireSignature || false
          : false
      );
    if (quote.hardCopyExtra && quote.hardCopyExtra.saveAddress) {
      setSaveAddress(
        quote.hardCopyExtra ? quote.hardCopyExtra.saveAddress || false : false
      );
      setAddressName(
        quote.hardCopyExtra ? quote.hardCopyExtra.addressName || "" : ""
      );
    }

      setSelectedMyAddress(
        quote.hardCopyExtra ? quote.hardCopyExtra.id || "" : ""
      );
      setNewAddressModal(
        quote.hardCopyExtra ? quote.hardCopyExtra.newAddress || "" : ""
      );
      setGeneralNote(quote.generalNotes || "");
      setClientFirstName(quote.clientFirstName ? quote.clientFirstName : "");
      setClientLastName(quote.clientLastName ? quote.clientLastName : "");
  }, [quote]);

  useEffect(() => {
    if (
      signedIn &&
      userData && teamData &&
      teamData.shipping &&
      teamData.shipping.length > 0
    ) {
      if (selectedMyAddress !== "") {
        const addressSelected = teamData.shipping.find(
          (address) => address.id === selectedMyAddress
        );
        if (addressSelected) {
          setSelectedMyAddress(addressSelected.id);
          setSelectedMyCountry(addressSelected.country);

          setHardCopyCountry(addressSelected.country);
          setHardCopyFirstName(addressSelected.firstName);
          setHardCopyLastName(addressSelected.lastName);
          setHardCopyState(addressSelected.region);
          setHardCopyCity(addressSelected.city);
          setHardCopyZipCode(addressSelected.zipCode);
          setHardCopyStreet(addressSelected.street);
          setHardCopyApartment(addressSelected.apartment);
          setAddressName(addressSelected.addressName);
        }
      } else {
        const address = teamData.shipping.find(
          (address) => address.default === true
        );
        if (address) {
          setSelectedMyAddress(address.id);
          setSelectedMyCountry(address.country);

          setHardCopyCountry(address.country);
          setHardCopyFirstName(address.firstName);
          setHardCopyLastName(address.lastName);
          setHardCopyState(address.region);
          setHardCopyCity(address.city);
          setHardCopyZipCode(address.zipCode);
          setHardCopyStreet(address.street);
          setHardCopyApartment(address.apartment);
          setAddressName(address.addressName);
        }
      }
      setAddressName(
        quote.hardCopyExtra ? quote.hardCopyExtra.addressName || "" : ""
      );
      return;
    } 
    if (
      signedIn &&
      userData &&
      userData.shipping &&
      userData.shipping.length > 0
    ) {
      if (selectedMyAddress !== "") {
        const addressSelected = userData.shipping.find(
          (address) => address.id === selectedMyAddress
        );
        if (addressSelected) {
          setSelectedMyAddress(addressSelected.id);
          setSelectedMyCountry(addressSelected.country);

          setHardCopyCountry(addressSelected.country);
          setHardCopyFirstName(addressSelected.firstName);
          setHardCopyLastName(addressSelected.lastName);
          setHardCopyState(addressSelected.region);
          setHardCopyCity(addressSelected.city);
          setHardCopyZipCode(addressSelected.zipCode);
          setHardCopyStreet(addressSelected.street);
          setHardCopyApartment(addressSelected.apartment);
          setAddressName(addressSelected.addressName);
        }
      } else {
        const address = userData.shipping.find(
          (address) => address.default === true
        );
        if (address) {
          setSelectedMyAddress(address.id);
          setSelectedMyCountry(address.country);

          setHardCopyCountry(address.country);
          setHardCopyFirstName(address.firstName);
          setHardCopyLastName(address.lastName);
          setHardCopyState(address.region);
          setHardCopyCity(address.city);
          setHardCopyZipCode(address.zipCode);
          setHardCopyStreet(address.street);
          setHardCopyApartment(address.apartment);
          setAddressName(address.addressName);
        }
      }
      setAddressName(
        quote.hardCopyExtra ? quote.hardCopyExtra.addressName || "" : ""
      );
      return;
    } 
      setNewAddressModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn, userData, teamData, selectedMyAddress]);

  useEffect(() => {
    if (hardCopy && hardCopyCountry === "") {
      setHardCopyMethod("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hardCopyCountry]);

  useEffect(() => {
    if (hardCopy && selectedMyAddress === "") {
      setSelectedMyMethod("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMyCountry]);

  const handleContinueToPayment = async () => {
    setContinueButton("Continuing...");
    try{
      if (hardCopy && !newAddressModal && selectedMyAddress === "") {
        showNotification(
          "Error",
          "Please select a address or add a new address.",
          "error"
        );
        return false;
      }

      const addressID = !newAddressModal ? selectedMyAddress : uuidv4();

      const country = newAddressModal ? hardCopyCountry.label : selectedMyCountry;
      const method = newAddressModal ? hardCopyMethod : selectedMyMethod;

      localStorage.setItem(
        "quote",
        JSON.stringify({
          ...quote,

          clientFirstName: clientFirstName,
          clientLastName: clientLastName,
          generalNotes: generalNote,
          files: JSON.stringify(
            quote.files
              .filter((f) => f.ref && f.url && f.status === "complete")
              .map((file) => ({
                name: file.name,
                ref: file.ref,
                url: file.url,
                type: "source",
                size: file.file ? file.file.size : file.size,
                format: file.file ? file.file.type : file.format,
                status: "complete",
                progress: 100,
                timestamp: file.timestamp,
              }))
          ),
          optionsSet: true,
          notarization: notarization,
          expedited: expedited,
          expeditedPlus: expeditedPlus,
          hardCopy: hardCopy,
          hardCopyExtra: hardCopy
            ? {
                id: addressID,
                newAddress: newAddressModal,
                country: country,
                countryIsoCode: hardCopyCountry.value,
                method: method,
                requireSignature: hardCopyRequireSignature,
                saveAddress: saveAddress,
                addressName: addressName,
                firstName: hardCopyFirstName,
                lastName: hardCopyLastName,
                recipient: hardCopyFirstName + " " + hardCopyLastName,
                region: hardCopyState.label,
                regionIsoCode: hardCopyState.value,
                city: hardCopyCity.label,
                cityIsoCode: hardCopyCity.value,
                zipCode: hardCopyZipCode,
                street: hardCopyStreet,
                apartment: hardCopyApartment,
              }
            : null,
        })
      );
      setQuote((q) => ({
        ...q,
        clientFirstName,
        clientLastName,
        generalNotes: generalNote,
        optionsSet: true,
        notarization: notarization,
        expedited: expedited,
        expeditedPlus: expeditedPlus,
        hardCopy: hardCopy,
        hardCopyExtra: hardCopy
          ? {
              id: addressID,
              newAddress: newAddressModal,
              country: country,
              countryIsoCode: hardCopyCountry.value,
              method: method,
              requireSignature: hardCopyRequireSignature,
              saveAddress: saveAddress,
              addressName: addressName,
              firstName: hardCopyFirstName,
              lastName: hardCopyLastName,
              recipient: hardCopyFirstName + " " + hardCopyLastName,
              region: hardCopyState.label,
              regionIsoCode: hardCopyState.value,
              city: hardCopyCity.label,
              cityIsoCode: hardCopyCity.value,
              zipCode: hardCopyZipCode,
              street: hardCopyStreet,
              apartment: hardCopyApartment,
            }
          : null,
      }));
      setContinueButton("Continue to Contact");
      transitionTo("/quote/contact");
    }catch (error) {
      console.log(error);
    }finally{
      setContinueButton(signedIn ? "Continue to Payment" : "Continue to Contact");
    }
  };


  const triggerContinue = () => {
    if (
      !(
        quote.languageFrom === "" ||
        checkForHardCopyFields() ||
        (hardCopy && saveAddress && addressName === "")
      )
    ) {
      handleContinueToPayment();
    }
  };

  useEnterKey(() => triggerContinue());

  const handleFocusDelivery = (isFocused) => {
    if (newAddressModal) {
      setNewDeliveryFocus({ delivery: isFocused, country: false });
    } else {
      setMyDeliveryFocus({ delivery: isFocused, country: false });
    }
  };

  const checkForHardCopyFields = () => {
    if (hardCopy) {
      if (
        newAddressModal
          ? hardCopyCountry === "" ||
          hardCopyMethod === "" ||
          hardCopyFirstName === "" ||
          hardCopyState === "" ||
          hardCopyCity === "" ||
          hardCopyZipCode === "" ||
          hardCopyStreet === ""
          : // hardCopyApartment === ""
          selectedMyAddress === "" ||
          selectedMyCountry === "" ||
          selectedMyMethod === ""
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const getHardCopyTotal = () => {
    return (
      (["United States", "Puerto Rico", "U.S. Virgin Islands"].includes(
        hardCopyCountry.label
      )
        ? hardCopyMethod === "priority"
          ? 19.95
          : 37.95
        : hardCopyMethod === "priority"
          ? 49.95
          : 78.95) + (hardCopyRequireSignature ? 4.99 : 0)
    );
  };

  const getExpeditedPlusAvaliblity = () => {
    const date = new Date();
    const time = date
      .toLocaleString("en-US", { timeZone: "America/New_York" })
      .split(",")
      .pop();
    const day = time.split(" ").pop() === "AM" ? true : false;
    const hour = time.split(":")[0];

    // eslint-disable-next-line eqeqeq
    if ((!day && hour >= 5) || (day && (hour < 8 || hour == 12))) {
      return false;
    } else {
      return true;
    }
  };

  const getExpeditedPlusByLanguage = () => {
    if (
      expeditedPlusLanguages.includes(quote.languageFrom) &&
      expeditedPlusLanguages.includes(quote.languageTo)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleExpedited = () => {
    setExpeditedPlus(false);
    setExpedited((e) => !e);
  };

  const handleExpeditedPlus = () => {
    setExpedited(false);
    setExpeditedPlus((e) => !e);
  };

  const getFullAddress = (address) => {
    const first = address.firstName ? address.firstName : address.recipient;
    const last =
      address.firstName && address.lastName ? " " + address.lastName : "";

    const name = first + last;

    return (
      name +
      ", " +
      address.country +
      ", " +
      address.region +
      ", " +
      address.city +
      ", " +
      address.zipCode +
      ", " +
      address.street +
      ", " +
      address.apartment
    );
  };

  const handleEditAddress = (address) => {
    setEditAddress(address.id);
    setEditAddressIconSelected("");

    setEditAddressName(address.addressName ? address.addressName : address.recipient || "");
    setEditCountry({ label: address.country, value: address.countryIsoCode } || "");
    setEditFirstName(address.firstName ? address.firstName : address.recipient || "");
    setEditLastName(address.lastName ? address.lastName : "");
    setEditState({ label: address.region, value: address.regionIsoCode } || "");
    setEditCity({ label: address.city, value: address.cityIsoCode } || "");
    setEditZipCode(address.zipCode || "");
    setEditStreet(address.street || "");
    setEditApartment(address.apartment || "");
  };

  const handleDeleteAddress = (address, isTeamAddress = true, notify = true) => {
    setDeleteBtnText("Deleting...");
    const newAddresses = isTeamAddress ? teamData && teamData.shipping.length > 0 ? teamData.shipping.filter(a => a.id !== address.id) : []
    : userData.shipping && userData.shipping.length > 0 ? userData.shipping.filter(a => a.id !== address.id) : [];

    setEditAddressIconSelected("");
    setEditAddress("");

    firestore.collection(isTeamAddress ? "teams":"users").doc(isTeamAddress ? userData.teamId : userData.id).update({
      shipping: newAddresses
    }).then(() => {
      setDeleteModalAddress(null);
      notify && showNotification('Success', "Address deleted successfully.", 'success');
    }).catch(() => {
      showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
    }).finally(() => {
      setDeleteBtnText("Delete Address");
    })

  }

 const handleUpdateAddress = (address, isTeamAddress = true) => {
     setSaveEditsBtnText("Saving...");
 
     const newEditedAddress = {
       addressName: editAddressName,
       firstName: editFirstName,
       lastName: editLastName,
       recipient: editFirstName + " " + editLastName,
       country: editCountry.label,
       countryIsoCode: editCountry.value || "",
       city: editCity.label,
       cityIsoCode: editCity.value || "",
       region: editState.label,
       regionIsoCode: editState.value || "",
       zipCode: editZipCode,
       street: editStreet,
       apartment: editApartment || "",
       id: address.id || uuidv4(),
       default: address.default || false
     }
 
     let newAddresses = [];
 
 
     if (address === "new" ) {
       if(isTeamAddress && teamData && teamData.shipping && teamData.shipping.length > 0){
         newAddresses = [...teamData.shipping, newEditedAddress];
       }else if(!teamData && userData.shipping && userData.shipping.length > 0){
       newAddresses = [...userData.shipping, newEditedAddress];
       }else{
         newAddresses = [newEditedAddress];
       }
     } else {
       newAddresses = isTeamAddress ? teamData.shipping.length > 0 ? teamData.shipping.map(a => a.id === address.id ? newEditedAddress : a) : [] : 
       userData.shipping.length > 0 ? userData.shipping.map(a => a.id === address.id ? newEditedAddress : a) : [];
     }
 
     firestore.collection((isTeamAddress && address=== "new") || isTeamAddress ? "teams" :"users")
     .doc((isTeamAddress && address=== "new") || isTeamAddress ? userData.teamId : userData.id).update({
       shipping: newAddresses
     }).then(() => {
       setSelectedMyAddress("");
       setEditAddressIconSelected("");
       setEditAddress("");
       setSaveEditsBtnText("Save");
       showNotification('Success', "Address updated successfully.", 'success');
     }).catch(() => {
       setSaveEditsBtnText("Save");
       showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
     })
 
  }

  const handleMyAddressClick = () => {
    setNewAddressModal(false);
    setEditAddress("");
    setEditAddressIconSelected("");
    setNewDeliveryFocus({ delivery: false, country: false });
    setMyDeliveryFocus({ delivery: false, country: false });
  };

  const handleNewAddressClick = () => {
    setNewAddressModal(true);
    setEditAddress("");
    setEditAddressIconSelected("");
    setNewDeliveryFocus({ delivery: false, country: false });
    setMyDeliveryFocus({ delivery: false, country: false });
  };

  const handleClientSelect = (client) => {
    setClientFirstName(client.firstName);
    setClientLastName(client.lastName);
  };


  return (
    <>
      <TopBar />

       {deleteModalAddress && <PopUpModal title={"Delete Address"} backBtnText="Back to Shipping Addresses" subText="Are you sure you want to delete this address?" text={deleteModalAddress.addressName} btnText={deleteBtnText}
            iconBgColor="#FFF6EA" deleteBtn={true} showClose onClose={() => setDeleteModalAddress(null)} onClick={() => { handleDeleteAddress(deleteModalAddress, userData.teamId ? true : false) }} onBackClick={() => setDeleteModalAddress(null)} disableBtn={deleteBtnText === "Deleting..."}>
            <ADDRESS />
          </PopUpModal>}

      <div className="mainOrderContainer">
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="2. Services" stage={2} stages={3} />
            <div></div>
          </div>
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <div id="mainPrimary" className="mainOrderPrimaryContent">
              <div className="quotePrimaryOptionsWrapper">
                <h3 className="quotePrimaryTitle">
                  Which optional services do you need?
                </h3>
                {quote.certified ? (
                  <div
                    className="quoteOptionalContainer firstQuoteOptionalContainer"
                    onClick={() => setNotarization((n) => !n)}
                    style={{
                      borderColor: notarization ? "#12ABBF" : "#E6E7E9",
                    }}
                  >
                    <div className="orderContentContainer">
                      <div className="orderIconWrapper">
                        <NOTRY className="icon" />
                      </div>
                      <div className="quoteOptionalTitleRow">
                        <div className="orderDetailsContainer">
                          <h5 className="orderPrimaryOptionTitle">
                            Notarization
                          </h5>
                          <p className="quotePrimaryOptionText">
                            Stamp and signature authenticating the translation
                            certification. Valid in all 50 states.
                          </p>
                        </div>
                        <div className="orderOptionalExtraContainer">
                          <p className="orderOptionalPrice">$34.90</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div
                  className={`quoteOptionalContainer ${quote.certified ? "": "mt-4"}`}
                  onClick={() => handleExpedited()}
                  style={{ borderColor: expedited ? "#12ABBF" : "#E6E7E9" }}
                >
                  <div className="orderContentContainer">
                    <div className="orderIconWrapper">
                      <EXPEDITED className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className="orderDetailsContainer">
                        <h5 className="orderPrimaryOptionTitle">
                          Expedited Turnaround
                          {getExpeditedFreeOrders(userData,teamData) > 0 && 
                          <span className="text-[#9A9FA7]">{" ("+ getExpeditedFreeOrders(userData, teamData) +  " free orders left) "}</span>}
                        </h5>
                        <p className="quotePrimaryOptionText">
                          Your order will be prioritized and turnaround time for
                          digital delivery reduced by 50%.
                        </p>
                      </div>
                      <div className="orderOptionalExtraContainer">
                        <p className="orderOptionalPrice">
                          {getExpeditedPriceLabel(false, userData, teamData)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="quoteOptionalContainer"
                  onClick={() => {
                    getExpeditedPlusAvaliblity() &&
                      getExpeditedPlusByLanguage() &&
                      handleExpeditedPlus();
                  }}
                  style={{
                    borderColor:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage() &&
                        expeditedPlus
                        ? "#12ABBF"
                        : "#E6E7E9",
                    opacity:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage()
                        ? 1
                        : 0.5,
                    cursor:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage()
                        ? "pointer"
                        : "default",
                  }}
                >
                  <div className="orderContentContainer">
                    <div className="orderIconWrapper">
                      <EXPEDITEDPLUS className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className="orderDetailsContainer">
                        <h5 className="orderPrimaryOptionTitle">
                          Expedited Turnaround Plus
                          {getExpeditedFreeOrders(userData,teamData) > 0 && 
                          <span className="text-[#9A9FA7]">{" ("+ getExpeditedFreeOrders(userData, teamData) +  " free orders left) "}</span>}
                        </h5>
                        <p className="quotePrimaryOptionText">
                          Your order will be prioritized and turnaround time for
                          digital delivery reduced by 83.33%.
                        </p>
                        {!(
                          getExpeditedPlusAvaliblity() &&
                          getExpeditedPlusByLanguage()
                        ) && (
                            <div className="expeditedPlusErrorWrap">
                              <p className="expeditedPlusErrorText">
                                {!getExpeditedPlusAvaliblity() &&
                                  getExpeditedPlusByLanguage()
                                  ? "Unavailable after 5 PM to 8 AM EST"
                                  : getExpeditedPlusAvaliblity() &&
                                    !getExpeditedPlusByLanguage()
                                    ? "Unavailable for non-Latin languages."
                                    : "Unavailable after 5 PM to 8 AM EST and for non-Latin languages."}
                              </p>
                            </div>
                          )}
                      </div>
                      <div className="orderOptionalExtraContainer">
                        <p className="orderOptionalPrice">
                          {getExpeditedPriceLabel(true, userData, teamData)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {quote.certified ? (
                  <div
                    className="quoteOptionalContainer"
                    style={{ borderColor: hardCopy ? "#12ABBF" : "#E6E7E9" }}
                  >
                    <div
                      className="orderContentContainer"
                      onClick={() => setHardCopy((n) => !n)}
                    >
                      <div className="orderIconWrapper">
                        <HARDCOPY className="icon" />
                      </div>
                      <div className="quoteOptionalTitleRow">
                        <div className="orderDetailsContainer">
                          <h5 className="orderPrimaryOptionTitle">
                            Mail Hard Copy
                          </h5>
                          <p className="quotePrimaryOptionText">
                            Original translation with wet ink signature(s)
                            shipped via USPS Priority or Express mail.
                          </p>
                        </div>
                        <div className="orderOptionalExtraContainer">
                          <p className="orderOptionalPrice">
                            {hardCopy &&
                              hardCopyCountry !== "" &&
                              hardCopyMethod !== "" &&
                              formatTotal(getHardCopyTotal())}
                          </p>
                        </div>
                      </div>
                    </div>

                    {hardCopy &&
                    signedIn &&
                    userData &&
                    ((userData.teamId && teamData && teamData.shipping &&
                    teamData.shipping.length > 0) ||
                    (userData.shipping &&
                    userData.shipping.length > 0)) ? (
                      <div className="hardCopyAddressTabWrap">
                        <div
                          className="hardCopyAddressTab"
                          onClick={handleMyAddressClick}
                        >
                          <div
                            className="hardCopyAddressTabText"
                            style={{
                              borderBottomWidth: !newAddressModal ? "2px" : 0,
                            }}
                          >
                            My Address
                          </div>
                        </div>
                        <div
                          className="hardCopyAddressTab"
                          onClick={handleNewAddressClick}
                        >
                          <div
                            className="hardCopyAddressTabText"
                            style={{
                              borderBottomWidth: newAddressModal ? "2px" : 0,
                            }}
                          >
                            New Address
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {hardCopy ? (
                      signedIn &&
                      userData &&
                      !newAddressModal ? (
                        <>
                          {userData.teamId && teamData && teamData.shipping && teamData.shipping.length > 0 &&
                          teamData.shipping.map((address, i) => (
                            <div
                              key={address.id}
                              className="hardCopyAddressContainer"
                              style={{
                                borderColor:
                                  selectedMyAddress === address.id
                                    ? "#12ABBF"
                                    : "#E6E7E9",
                              }}
                            >
                              <div className="quoteOptionalTitleRow">
                                <div
                                  className="hardCopyAddressDetails"
                                  onClick={() =>
                                    setSelectedMyAddress(address.id)
                                  }
                                >
                                  <h6 className="hardCopyAddressTitle">
                                    {address.addressName
                                      ? address.addressName
                                      : address.recipient}{" "}
                                    <span>
                                      {address.default && "(primary)"}
                                    </span>
                                  </h6>
                                  <p className="hardCopyAddressText">
                                    {getFullAddress(address)}
                                  </p>
                                </div>
                                <div
                                  className="hardCopyAddressIconWrap"
                                  onMouseOver={() =>
                                    setEditAddressIconSelected(address.id)
                                  }
                                  onMouseLeave={() =>
                                    setEditAddressIconSelected("")
                                  }
                                >
                                  {editAddressIconSelected === address.id ? (
                                    <MORESELECTED
                                      className="hardCopyAddressIcon"
                                      onClick={() =>
                                        setEditAddressIconSelected("")
                                      }
                                    />
                                  ) : (
                                    <MORE
                                      className="hardCopyAddressIcon"
                                      onClick={() => {
                                        setEditAddressIconSelected(address.id);
                                      }}
                                    />
                                  )}
                                  {editAddressIconSelected === address.id && (
                                    <div className="hardCopyAddressEditWrap">
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() =>
                                          handleEditAddress(address)
                                        }
                                      >
                                        Edit
                                      </div>
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() => { setDeleteModalAddress(address); setEditAddress(""); setEditAddressIconSelected("") }}
                                      >
                                        Delete
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {editAddress === address.id && (
                                <div className="editInputsContainer">
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Address Name"}
                                      value={editAddressName}
                                      onChange={setEditAddressName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                      <SelectSearch
                                      placeholder="Select Country"
                                      value={editCountry.value}
                                      setValue={(val) => setEditCountry(countries.find(c => c.value === val))}
                                      list={countries}
                                      activeDropdown={activeDropdown}
                                       setActiveDropdown={setActiveDropdown}
                                       dropdownId="country"
                                      />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"First Name"}
                                      value={editFirstName}
                                      onChange={setEditFirstName}
                                    />
                                    <FormTextInput
                                      placeholder={"Last Name"}
                                      value={editLastName}
                                      onChange={setEditLastName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <SelectSearch
                                    placeholder="Select State"
                                    value={editState ? editState.value : ""}
                                    setValue={(val) => setEditState(getStates(editCountry.value).find(s => s.value === val))}
                                    list={getStates(editCountry.value)}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownId="state"
                                    disabled={!editCountry.value}
                                    />
                                    <SelectSearch
                                    placeholder="Select City"
                                    value={editCity ? editCity.value : ""}
                                    setValue={(val) => setEditCity(getCities(editState.value,editCountry.value).find(c => c.value === val))}
                                    list={getCities(editState.value,editCountry.value)}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownId="city"
                                    disabled={!editCountry.value || !editState.value}
                                    />
                                    <FormTextInput
                                      placeholder={"ZIP code"}
                                      value={editZipCode}
                                      onChange={setEditZipCode}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Street/Address"}
                                      value={editStreet}
                                      onChange={setEditStreet}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Apartment, suite, etc."}
                                      value={editApartment}
                                      onChange={setEditApartment}
                                    />
                                  </div>
                                  <div className="editInputBtnContainer">
                                    <NewButton
                                      onClick={() =>
                                        handleUpdateAddress(address, true)
                                      }
                                      disabled={
                                        saveEditsBtnText === "Saving..."
                                      }
                                      text={saveEditsBtnText}
                                      width="150px"
                                    />
                                    <NewButton
                                      onClick={() => setEditAddress("")}
                                      text={"Cancel"}
                                      icon={false}
                                      whiteBtn
                                      back={true}
                                      width="150px"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                          {userData.shipping && userData.shipping.length > 0 && userData.shipping.map((address, i) => (
                            <div
                              key={address.id}
                              className="hardCopyAddressContainer"
                              style={{
                                borderColor:
                                  selectedMyAddress === address.id
                                    ? "#12ABBF"
                                    : "#E6E7E9",
                              }}
                            >
                              <div className="quoteOptionalTitleRow">
                                <div
                                  className="hardCopyAddressDetails"
                                  onClick={() =>
                                    setSelectedMyAddress(address.id)
                                  }
                                >
                                  <h6 className="hardCopyAddressTitle">
                                    {address.addressName
                                      ? address.addressName
                                      : address.recipient}{" "}
                                    <span>
                                      {!userData.teamId && address.default ? "(primary)" : ""}
                                    </span>
                                  </h6>
                                  <p className="hardCopyAddressText">
                                    {getFullAddress(address)}
                                  </p>
                                </div>
                                <div
                                  className="hardCopyAddressIconWrap"
                                  onMouseOver={() =>
                                    setEditAddressIconSelected(address.id)
                                  }
                                  onMouseLeave={() =>
                                    setEditAddressIconSelected("")
                                  }
                                >
                                  {editAddressIconSelected === address.id ? (
                                    <MORESELECTED
                                      className="hardCopyAddressIcon"
                                      onClick={() =>
                                        setEditAddressIconSelected("")
                                      }
                                    />
                                  ) : (
                                    <MORE
                                      className="hardCopyAddressIcon"
                                      onClick={() => {
                                        setEditAddressIconSelected(address.id);
                                      }}
                                    />
                                  )}
                                  {editAddressIconSelected === address.id && (
                                    <div className="hardCopyAddressEditWrap">
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() =>
                                          handleEditAddress(address)
                                        }
                                      >
                                        Edit
                                      </div>
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() => { setDeleteModalAddress(address); setEditAddress(""); setEditAddressIconSelected("") }}
                                      >
                                        Delete
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {editAddress === address.id && (
                                <div className="editInputsContainer">
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Address Name"}
                                      value={editAddressName}
                                      onChange={setEditAddressName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <SelectSearch
                                    placeholder="Select Country"
                                    value={editCountry.value}
                                    setValue={(val) => setEditCountry(countries.find(c => c.value === val))}
                                    list={countries}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownId="country"
                                  />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"First Name"}
                                      value={editFirstName}
                                      onChange={setEditFirstName}
                                    />
                                    <FormTextInput
                                      placeholder={"Last Name"}
                                      value={editLastName}
                                      onChange={setEditLastName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <SelectSearch
                                      placeholder="Select State"
                                      value={editState ? editState.value : ""}
                                      setValue={(val) => setEditState(getStates(editCountry.value).find(s => s.value === val))}
                                      list={getStates(editCountry.value)}
                                      activeDropdown={activeDropdown}
                                      setActiveDropdown={setActiveDropdown}
                                      dropdownId="state"
                                      disabled={!editCountry.value}
                                    />
                                    <SelectSearch
                                      placeholder="Select City"
                                      value={editCity ? editCity.value : ""}
                                      setValue={(val) => setEditCity(getCities(editState.value,editCountry.value).find(c => c.value === val))}
                                      list={getCities(editState.value,editCountry.value)}
                                      activeDropdown={activeDropdown}
                                      setActiveDropdown={setActiveDropdown}
                                      dropdownId="city"
                                      disabled={!editCountry.value || !editState.value}
                                    />
                                    <FormTextInput
                                      placeholder={"ZIP code"}
                                      value={editZipCode}
                                      onChange={setEditZipCode}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Street/Address"}
                                      value={editStreet}
                                      onChange={setEditStreet}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Apartment, suite, etc."}
                                      value={editApartment}
                                      onChange={setEditApartment}
                                    />
                                  </div>
                                  <div className="editInputBtnContainer">
                                    <NewButton
                                      onClick={() =>
                                        handleUpdateAddress(address, false)
                                      }
                                      disabled={
                                        saveEditsBtnText === "Saving..."
                                      }
                                      text={saveEditsBtnText}
                                      width="150px"
                                    />
                                    <NewButton
                                      onClick={() => setEditAddress("")}
                                      text={"Cancel"}
                                      icon={false}
                                      whiteBtn
                                      back={true}
                                      width="150px"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                          <div className="quoteDetailsInputsContainer">
                            <div className="quoteDetailsSelectContainer">
                              <SearchSelect
                                list={
                                  selectedMyCountry
                                    ? [
                                      "United States",
                                      "Puerto Rico",
                                      "U.S. Virgin Islands",
                                    ].includes(selectedMyCountry)
                                      ? USPriorDelivery
                                      : otherCitiesDelivery
                                    : []
                                }
                                placeholder="Delivery"
                                value={selectedMyMethod}
                                focus={myDeliveryFocus.delivery}
                                setValue={setSelectedMyMethod}
                                setFocus={handleFocusDelivery}
                              />
                            </div>
                          </div>

                          <div
                            className="hardCopyCheckboxLine"
                            onClick={() =>
                              setHardCopyRequireSignature((hc) => !hc)
                            }
                          >
                            <div
                              className={`${hardCopyRequireSignature && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{
                                  opacity: hardCopyRequireSignature ? 1 : 0,
                                }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">
                              Require signature for delivery $4.99
                            </p>
                          </div>
                        </>
                      ) : (
                        <div className="editInputsContainer">
                          {/* <div className="hardCopyLineSeparator" /> */}
                          <div className="quoteDetailsInputsContainer">
                             <SelectSearch
                                placeholder="Select Country"
                                value={hardCopyCountry? hardCopyCountry.value : ""}
                                setValue={(val) => setHardCopyCountry(countries.find(c => c.value === val))}
                                list={countries}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownId="country"
                              />
                            <SearchSelect
                              list={
                                hardCopyCountry
                                  ? [
                                    "United States",
                                    "Puerto Rico",
                                    "U.S. Virgin Islands",
                                  ].includes(hardCopyCountry.label)
                                    ? USPriorDelivery
                                    : otherCitiesDelivery
                                  : []
                              }
                              placeholder="Delivery"
                              value={hardCopyMethod}
                              focus={newDeliveryFocus.delivery}
                              setValue={setHardCopyMethod}
                              setFocus={handleFocusDelivery}
                            />
                          </div>
                          <div className="quoteDetailsInputsContainer">
                            <FormTextInput
                              placeholder={"First Name"}
                              value={hardCopyFirstName}
                              onChange={setHardCopyFirstName}
                            />
                            <FormTextInput
                              placeholder={"Last Name"}
                              value={hardCopyLastName}
                              onChange={setHardCopyLastName}
                            />
                          </div>
                          <div className="quoteDetailsInputsContainer">
                          <SelectSearch
                            placeholder="Select State"
                            value={hardCopyState ? hardCopyState.value : ""}
                            setValue={(val) => setHardCopyState(getStates(hardCopyCountry.value).find(s => s.value === val))}
                            list={getStates(hardCopyCountry.value)}
                            activeDropdown={activeDropdown}
                            setActiveDropdown={setActiveDropdown}
                            dropdownId="state"
                            disabled={!hardCopyCountry.value}
                          />
                          <SelectSearch
                            placeholder="Select City"
                            value={hardCopyCity ? hardCopyCity.value : ""}
                            setValue={(val) =>setHardCopyCity(getCities(hardCopyState.value,hardCopyCountry.value).find(c => c.value === val))}
                            list={getCities(hardCopyState.value,hardCopyCountry.value)}
                            activeDropdown={activeDropdown}
                            setActiveDropdown={setActiveDropdown}
                            dropdownId="city"
                            disabled={!hardCopyCountry.value || !hardCopyState.value}
                          />

                            <FormTextInput
                              placeholder={"ZIP code"}
                              value={hardCopyZipCode}
                              onChange={setHardCopyZipCode}
                            />
                          </div>
                          <div className="quoteDetailsInputsContainer">
                            <FormTextInput
                              placeholder={"Street/Address"}
                              value={hardCopyStreet}
                              onChange={setHardCopyStreet}
                            />
                          </div>
                          <div className="quoteDetailsInputsContainer">
                            <FormTextInput
                              placeholder={"Apartment, suite, etc."}
                              value={hardCopyApartment}
                              onChange={setHardCopyApartment}
                            />
                          </div>
                          <div
                            className="hardCopyCheckboxLine"
                            onClick={() =>
                              setHardCopyRequireSignature((hc) => !hc)
                            }
                          >
                            <div
                              className={`${hardCopyRequireSignature && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{
                                  opacity: hardCopyRequireSignature ? 1 : 0,
                                }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">
                              Require signature for delivery $4.99
                            </p>
                          </div>
                          {userData && <div
                            className="hardCopyCheckboxLine"
                            onClick={() => setSaveAddress((hc) => !hc)}
                          >
                            <div
                              className={`${saveAddress && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{ opacity: saveAddress ? 1 : 0 }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">Save address</p>
                          </div>}
                          {saveAddress ? (
                            <div className="quoteDetailsInputsContainer">
                              <FormTextInput
                                placeholder={"Address Name"}
                                value={addressName}
                                onChange={setAddressName}
                              />
                            </div>
                          ) : null}
                        </div>
                      )
                    ) : null}
                  </div>
                ) : null}
              </div>

              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">
                  General Notes <span>{`(optional)`}</span>
                </h4>
                <div className="orderCountContainer">
                  <p className="orderCountAuxText">
                    Please include any notes your translation team might need
                    including the preferred spelling for all people and places.
                  </p>
                  <FormTextInput
                    width={"100%"}
                    placeholder={"Notes"}
                    value={generalNote}
                    onChange={setGeneralNote}
                  />
                </div>
              </div>
              {userData && userData.teamId && <div className="quotePrimaryOptionsWrapper">
                <h3 className="quotePrimaryTitle">
                  Your Client{" "}
                  <span style={{ color: "#9A9FA7", fontWeight: 500 }}>
                    {"(optional)"}
                  </span>
                </h3>
                <p
                  className="quotePrimaryOptionText"
                  style={{ marginBottom: "1rem" }}
                >
                  If submitted, the client field will be included in emails, in
                  translations, and in your invoice.
                </p>
                <div className="quoteDetailsInputsContainer">
                  <FormTextInput
                    placeholder={"Client First Name"}
                    value={clientFirstName}
                    onChange={setClientFirstName}
                  />
                  <FormTextInput
                    placeholder={"Client Last Name"}
                    value={clientLastName}
                    onChange={setClientLastName}
                  />
                </div>
                {similarClients.length > 0 && (
                  <div className="orderOptionSimilarClient">
                    <p className="orderOptionSimilarClientText">
                      We found similar clients in your account. Would you like
                      to select one of them for this order?
                    </p>
                    <div className="orderOptionSimilarClientTabs">
                      {similarClients.map((client) => (
                        <div
                          key={client.id}
                          className="orderOptionSimilarClientTab"
                          style={{
                            borderColor:
                              client.firstName + client.lastName ===
                                clientFirstName + clientLastName
                                ? "#B3E4EB"
                                : "#E6E7E9",
                          }}
                          onClick={() => handleClientSelect(client)}
                        >
                          {(client.firstName ? client.firstName : client.name) +
                            " " +
                            (client.lastName ? client.lastName + " " : "") +
                            "(" +
                            client.totalOrders +
                            " quotes)"}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>}

              <div>
                <div className="quoteSubmitButtonContainer">
                  <NewButton
                    text="Back to Details"
                    onClick={(e) => transitionTo("/quote/details", e)}
                    back={true}
                  />
                  <NewButton
                    text={continueButton}
                    disabled={
                      quote.languageFrom === "" ||
                      checkForHardCopyFields() ||
                      (hardCopy && saveAddress && addressName === "")
                    }
                    onClick={() => handleContinueToPayment()}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mainOrderSecondaryContent">
            <div className="mainOrderSecondaryContentWrap relative">
              <div className="orderSummary">
                <h3 className="quotePrimaryTitle">WHAT TO EXPECT</h3>
                <div className="quoteSecondarySub">
                  We’ll respond quickly with a formal quote covering the cost
                  and turnaround time for your translation project.
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Free quote, no obligation to buy
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Final pricing with no surprises
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Estimated turnaround time
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Quick convert to order when ready
                  </div>
                </div>
                <div className="quoteSecondaryLine">
                  <Check size={15} className="quoteSecondaryLineIcon" />
                  <div className="quoteSecondaryLineText">
                    Quote is guaranteed for 30 days
                  </div>
                </div>
              </div>

              <div>
                <SecureAndPrivate />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuoteOptions;
